<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  width: 100vw;
  min-height: 100vh;
  margin: 0;
  padding: 0;
}
</style>
